<template>
    <div>
        <div ref="chart" style="min-height: 400px"></div>
        <div v-show="showExport" class="flex">
            <export-image></export-image>
            <a class="btn inline-block" href="#/export">
                <i class="fa fa-download"></i> Export Data
            </a>
        </div>
    </div>
</template>

<script>
    export default {

        props: {
            width: {
                default: null
            },
            height: {
                default: null
            },
            showExport: {
                default: true,
            },
            minimize: {
                default: false,
            }
        },

        data: () => ({
            chart: {},
        }),

        mounted() {
            this.newChart();
        },

        watch: {
            'chartJSON': {
                handler() {
                    this.newChart();
                },
            },
            width() {
                this.newChart();
            },
            height() {
                this.newChart();
            },
        },

        computed: {
            legend() {
                if (this.minimize) {
                    return {
                        enabled: false,
                    };
                }
                return {
                    itemStyle: {
                        width: 550,
                    },
                    enabled: !this.isColumn,
                };
            },
            credits() {
                if (this.minimize) {
                    return {
                        enabled: false,
                    };
                }
                return {
                    enabled: true,
                    href: 'https://www.now.cx/',
                    text: 'Source: ' + this.$store.getters.sources,
                };
            },
            yAxis() {
                if (this.minimize) {
                    return {
                        title: {
                            enabled: false,
                            text: undefined,
                        },
                    };
                }
                return this.$store.getters.yAxis.map(title => ({title: {text: title}}));
            },
            xAxis() {
                if (this.minimize) {
                    return {
                        title: {
                            enabled: false,
                            text: undefined,
                        },
                    };
                }
                if (this.isColumn) {
                    let categories = this.series[0].data.map(function (item) {
                        return item[0];
                    });

                    return {
                        categories: categories,
                        type: 'category',
                        title: {
                            text: null
                        },
                        labels: {
                            rotation: -45,
                            /*style: {
                                fontSize: '13px',
                                fontFamily: 'Verdana, sans-serif'
                            }*/
                        },
                        //min: min,
                        tickmarkPlacement: 'on',
                        //tickInterval: 1,
                        //minRange: 1
                    };
                }
                return {
                    type: 'datetime'
                }
            },
            chartJSON() {
                const text = this.$store.state.rawData.headline;

                let plotOptions = {};

                if (this.$store.state.type === 'bar' || this.$store.state.type === 'area') {
                    plotOptions = {
                        series: {
                            stacking: this.$store.state.stacking,
                        },
                    };
                }

                if (this.$store.state.type === 'column') {
                    plotOptions = {
                        column: {
                            stacking: this.$store.state.stacking,
                            dataLabels: {
                                //allowOverlap: true,
                                /*enabled: true,
                                formatter: function() {
                                    console.log(this.point.name);
                                    return 'foo:' + this.point.name;
                                }*/
                            }
                        },
                    };
                }

                return {
                    chart: {
                        backgroundColor: this.$store.state.backgroundColor,
                        renderTo: this.$refs.chart,
                        type: this.$store.state.type,
                    },
                    plotOptions: plotOptions,
                    title: {
                        text: text,
                    },
                    series: this.$store.getters.timeSeries,
                    yAxis: this.yAxis,
                    xAxis: this.xAxis,
                    legend: this.legend,
                    exporting: {
                        buttons: {
                            contextButton: {
                                enabled: false,
                            }
                        }
                    },
                    credits: this.credits,
                    tooltip: {
                        shared: this.$store.getters.timeSeries.length <= 5,
                    },
                };
            }
        },

        methods: {
            newChart() {
                let json = this.chartJSON;
                json.chart.renderTo = this.$refs.chart;
                this.chart = null;
                if (this.height !== null && this.width !== null) {
                    json.chart.width = this.width;
                    json.chart.height = this.height;
                }
                this.chart = new Highcharts.Chart(json);
            },
            exportChart(type) {
                this.chart.exportChart({type: type});
            },
        }
    }
</script>
